/***
 * This file manages all the local images (non-icon)
 */

const Local = {
  Authorised:       '/images/authorised.png',
  AvatarDefault:    '/images/avatar-default.png',
  Placeholder:      '/images/placeholder.png',
  PromoCodesSample: '/images/promoCodesSample.jpeg',
  SampleAreaMarker: '/images/sampleAreaMarker.jpeg',
  Spinner:          '/images/spinner.gif',

  MallNavigation: {
    ATM:            '/images/mall-navigation/ATM.png',
    Babycare:       '/images/mall-navigation/Babycare.png',
    Escalator:      '/images/mall-navigation/Escalator.png',
    FemaleToilet:   '/images/mall-navigation/Female Toilet.png',
    Gate:           '/images/mall-navigation/Gate.png',
    HandicapToilet: '/images/mall-navigation/Handicap Toilet.png',
    Information:    '/images/mall-navigation/Information.png',
    Lift:           '/images/mall-navigation/Lift.png',
    MaleToilet:     '/images/mall-navigation/Male Toilet.png',
    Path:           '/images/mall-navigation/Path.png',
    SalatRoom:      '/images/mall-navigation/Salat Room.png',
    Staircase:      '/images/mall-navigation/Staircase.png',
    Store:          '/images/mall-navigation/Store.png',
    TaxiStand:      '/images/mall-navigation/Taxi Stand.png',
  },
  MarkerPoi:              '/images/marker-poi.svg',
  GPSLocate:              '/images/icon-my-location.svg',
  PoiPhotoLocationMarker: '/images/poi-photo-location-marker.svg',
  GPSMarker:              '/images/gps-marker.png',
};

export default {
  Local,
};
